import { Package } from "lucide-react"

const EmptyState = () => {
  return (
    <div className="py-16 text-center">
      <Package className="h-10 w-10 mx-auto text-gray-400 dark:text-neutral-600 opacity-40" />
      <p className="mt-4 text-gray-500 dark:text-neutral-400">Aucun produit n'est en dessous de son niveau de stock minimum.</p>
    </div>
  )
}

export default EmptyState